import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { connect, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { mapVtrStateToProps } from "../../services/mapStateToProps";
import Spinner from "../../components/common/Spinner";
import DefaultButton from "../../components/DefaultButton";
import {
  dateTimeSavedToDisplay,
  getCurrentOpenTrip,
} from "../../constants/vtrTrip";
import moment from "moment";
import { getMaxDate, getMinDate } from "../../constants/dateFunctions";
import { mapDispatchToProps } from "../../constants/dispatchNewTripForm";
import TripReviewRedirect from "../../components/TripReviewRedirect";
import LandDate from "../../components/LandDate";
import TripReviewBackButton from "../../components/TripReviewBackButton";
import Grid from "@mui/material/Grid";
import { success } from "../../constants/colors";
import LobsterForm from "../../forms/LobsterForm/LobsterForm";
import {
  BUOY_LINES_EMPTY,
  BUOY_LINES_FORMAT,
  AVG_NUMBER_TRAPS_INVALID,
  AVG_NUM_TRAPS_EMPTY,
  TOTAL_TRAPS_WATER_INVALID,
  TOTAL_TRAPS_WATER_EMPTY,
  DATE_LAND_AFTER,
  DATE_LAND_BEFORE,
  DATE_LAND_EMPTY,
} from "../../constants/ErrorText";
import { getFieldLabel, getErrorText } from "../../constants/Helpers";

function LandingDatePage({ actions, ...props }) {
  const { vtrTrip, auth, helpText } = useSelector((state) => state);
  const location = useLocation();
  const [displayDateLand, setDisplayDateLand] = useState(null);
  const [dateLand, setDateLand] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isEffortTrip, setIsEffortTrip] = useState(false);
  const [values, setValues] = useState({
    trapsInWater: "",
    trapsPerString: "",
    buoyLines: "",
  });

  const _next = (event, value) => {
    event.preventDefault();
    let errors = [];
    if (values.date_land === "" || values.date_land === null) {
      errors.push(getErrorText("trip", "date_land", DATE_LAND_EMPTY));
    } else {
      let savedDateLand = moment(values.date_land, "YYMMDDHHmm");
      let minDate = getMinDate();
      if (savedDateLand < minDate) {
        errors.push(
          getFieldLabel("trip", "date_land", DATE_LAND_BEFORE) +
            `(${getMinDate})`
        );
      }
      let maxDate = getMaxDate();
      if (savedDateLand > maxDate) {
        errors.push(getErrorText("trip", "date_land", DATE_LAND_AFTER));
      }
    }
    // * Validate fields when report_type is a Lobster trip
    // * and the trip has effort(s)
    if (values.report_type === "2" && isEffortTrip) {
      if (
        values.trapsInWater === "" ||
        values.trapsInWater === null ||
        Number.isNaN(Number(values.trapsInWater))
      ) {
        errors.push(
          getErrorText("trip", "trapsInWater", TOTAL_TRAPS_WATER_EMPTY)
        );
      }
      if (!Number.isInteger(Number(values.trapsInWater))) {
        errors.push(
          getErrorText("trip", "trapsInWater", TOTAL_TRAPS_WATER_INVALID)
        );
      }
      if (
        values.trapsPerString === "" ||
        values.trapsPerString === null ||
        Number.isNaN(Number(values.trapsPerString))
      ) {
        errors.push(
          getErrorText("trip", "trapsPerString", AVG_NUM_TRAPS_EMPTY)
        );
      }
      if (!Number.isInteger(Number(values.trapsPerString))) {
        errors.push(
          getErrorText("trip", "trapsPerString", AVG_NUMBER_TRAPS_INVALID)
        );
      }
      if (
        values.buoyLines === "" ||
        values.buoyLines === null ||
        Number.isNaN(Number(values.buoyLines))
      ) {
        errors.push(getErrorText("trip", "totNrBuoyLines", BUOY_LINES_EMPTY));
      }
      if (!Number.isInteger(Number(values.buoyLines))) {
        errors.push(getErrorText("trip", "totNrBuoyLines", BUOY_LINES_FORMAT));
      }
    }
    actions.setError(errors);
    if (errors.length > 0) {
      console.log("landDatePage", errors);
      return;
    }
    if (value === "Save") {
      actions.updateTrip(
        {
          ...values,
          display_date_land: displayDateLand,
          date_land: dateLand,
          isLoaded,
        },
        auth.client_id,
        location.state.trip_id
      );
    }
  };

  const _handleInputChange = (event) => {
    const { name, value } = event.target;
    setValues({ ...values, [name]: value });
  };

  const handleDateLandChange = (date) => {
    if (date && date.hasOwnProperty("_d")) {
      let newDateTime = date._d;
      if (newDateTime !== "") {
        const dt = moment(newDateTime, "DD-MM-YYYY LT");
        const bDateTime = dt.format("YYMMDDHHmm");
        setDisplayDateLand(newDateTime);
        setDateLand(bDateTime);
      } else {
        setDisplayDateLand(newDateTime);
        setDateLand("");
      }
    }
  };

  const dateLandNowHandler = (event) => {
    event.preventDefault();
    let d = moment();
    const format = "DD-MMM-YY LT";
    const date_land = d.format("YYMMDDHHmm");
    const display_date_land = d.format(format);
    setDisplayDateLand(display_date_land);
    setDateLand(date_land);
  };

  useEffect(() => {
    let allOpenTrips = vtrTrip.allOpenTrips;
    let currentTrip = getCurrentOpenTrip(allOpenTrips, location.state.trip_id);
    setIsLoaded(true);
    let newState = {};
    newState.trip_type = currentTrip.trip_type;
    newState.report_type = currentTrip.report_type;

    if (currentTrip && currentTrip.date_land) {
      let displayDateSail = dateTimeSavedToDisplay(currentTrip.date_land);
      setDateLand(currentTrip.date_land);
      setDisplayDateLand(displayDateSail);
    }
    newState.trapsInWater = currentTrip.trapsInWater;
    newState.trapsPerString = currentTrip.trapsPerString;
    newState.buoyLines = currentTrip.buoyLines;
    // * In case has effort(s) should present lobster form when needed.
    if (currentTrip && currentTrip.no_effort_trip_reason === "0") {
      setIsEffortTrip(true);
    }
    setValues({ ...values, ...newState });
    actions.resetTripRedirect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (vtrTrip.redirect === true) {
    return (
      <TripReviewRedirect
        trip_id={location.state.trip_id}
        client_id={auth.client_id}
      />
    );
  }

  if (isLoaded === false) {
    return (
      <div>
        <Spinner />
      </div>
    );
  }

  return (
    <div className="trip-form-container">
      <LandDate
        handleLandDateChange={handleDateLandChange}
        display_land_date={displayDateLand}
        landDateNowHandler={dateLandNowHandler}
        helpText={helpText.helpText}
      />

      {values.report_type === "2" && isEffortTrip && (
        <LobsterForm
          handleInputChange={_handleInputChange}
          trapsInWater={values.trapsInWater}
          trapsPerString={values.trapsPerString}
          buoyLines={values.buoyLines}
        />
      )}

      <Box mt={5} width="100%" align="center" className="bottom-nav-container">
        <Grid container justifyContent="center" alignItems="center">
          <Grid item xs="auto" className="margRight20">
            <TripReviewBackButton
              trip_id={location.state.trip_id}
              client_id={auth.client_id}
            />
          </Grid>
          <Grid item xs="auto">
            <DefaultButton
              changeHandler={_next}
              buttonText={"Save"}
              bgColor={success}
            />
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

export default connect(mapVtrStateToProps, mapDispatchToProps)(LandingDatePage);
